import { seriesSvgMulti } from '@d3fc/d3fc-series';
import { middleLine } from 'widgets/signalTiles/rsiTile/components/chart/series/middleLineSeries';
import { belowSeries } from 'widgets/signalTiles/rsiTile/components/chart/series/belowLineSeries.ts';
import { aboveSeries } from 'widgets/signalTiles/rsiTile/components/chart/series/aboveLineSeries';
import { boundaryLines } from 'widgets/signalTiles/rsiTile/components/chart/series/boundaryLines';

export const getRsiTileSeries = (
    lowerBoundary: number,
    upperBoundary: number
) =>
    seriesSvgMulti().series([
        ...aboveSeries(upperBoundary),
        middleLine,
        ...belowSeries(lowerBoundary),
        ...boundaryLines(lowerBoundary, upperBoundary),
    ]);
